import axiosInstance from '../axiosInstance';

export const createPathfinderSession = async (goalType, phase) => {
  const response = await axiosInstance.post('/pathfinder/sessions', { goalType, phase });
  return response.data.data;
};

export const getPathfinderQuestions = async (goalType, phase) => {
  const params = {};
  if (goalType) params.goalType = goalType;
  if (phase) params.phase = phase;
  const response = await axiosInstance.get('/pathfinder/meta/questions', { params });
  return response.data.data;
};

export const getLatestPathfinderSession = async () => {
  const response = await axiosInstance.get('/pathfinder/sessions/latest');
  return response.data.data;
};

export const getPathfinderSession = async (sessionId) => {
  const response = await axiosInstance.get(`/pathfinder/sessions/${sessionId}`);
  return response.data.data;
};

export const savePathfinderSection = async (sessionId, sectionCode, payload) => {
  const response = await axiosInstance.put(
    `/pathfinder/sessions/${sessionId}/sections/${sectionCode}`,
    payload,
  );
  return response.data.data;
};

export const searchMajors = async (keyword) => {
  const response = await axiosInstance.get('/pathfinder/meta/majors/search', { params: { keyword } });
  return response.data.data;
};

export const savePathfinderExperiences = async (sessionId, experiences) => {
  const response = await axiosInstance.put(
    `/pathfinder/sessions/${sessionId}/experiences`,
    { experiences },
  );
  return response.data.data;
};

export const searchTools = async (keyword) => {
  const response = await axiosInstance.get('/pathfinder/meta/tools/search', { params: { keyword } });
  return response.data.data;
};

export const searchUniversities = async (keyword) => {
  const response = await axiosInstance.get('/pathfinder/meta/universities/search', { params: { keyword } });
  return response.data.data;
};

export const searchSchools = async (keyword) => {
  const response = await axiosInstance.get('/pathfinder/meta/schools/search', { params: { keyword } });
  return response.data.data;
};

export const evaluatePathfinderSession = async (sessionId, includeRecommendation = true) => {
  const response = await axiosInstance.post(`/pathfinder/sessions/${sessionId}/evaluate`, {
    includeRecommendation,
  });
  return response.data.data;
};

export const getPathfinderEvidenceCards = async (sessionId) => {
  const response = await axiosInstance.get(`/pathfinder/sessions/${sessionId}/evidence-cards`);
  return response.data.data;
};

export const getPathfinderEvidenceUploadUrl = async (sessionId, fileName) => {
  const response = await axiosInstance.post(
    `/pathfinder/sessions/${sessionId}/evidence/upload-url`,
    null,
    { params: { fileName } }
  );
  return response.data.data;
};

export const updatePathfinderEvidenceStatus = async (
  sessionId,
  variableName,
  status = 'UPLOADED'
) => {
  const encodedVariableName = encodeURIComponent(variableName);
  const response = await axiosInstance.put(
    `/pathfinder/sessions/${sessionId}/evidence/${encodedVariableName}`,
    { status }
  );
  return response.data.data;
};

export const createPathfinderEvidenceFile = async (sessionId, payload) => {
  const response = await axiosInstance.post(
    `/pathfinder/sessions/${sessionId}/evidence/files`,
    payload
  );
  return response.data.data;
};

export const deletePathfinderEvidenceFile = async (sessionId, fileId) => {
  const response = await axiosInstance.delete(
    `/pathfinder/sessions/${sessionId}/evidence/files/${fileId}`
  );
  return response.data.data;
};

export const getPathfinderEvidenceScorePreview = async (sessionId, variableName) => {
  const encodedVariableName = encodeURIComponent(variableName);
  const response = await axiosInstance.get(
    `/pathfinder/sessions/${sessionId}/evidence/${encodedVariableName}/score-preview`
  );
  return response.data.data;
};
